module.exports = __webpack_public_path__ + "img/1a.0eb5515d.svg";